export default __webpack_public_path__ + "static/media/coinBlueAndWhite.7cb6b91e.png";